module.exports = {"150922103":"长顺镇","150922104":"朝阳镇","150922105":"七号镇","150922200":"德包图乡","150922201":"公腊胡洞乡","150922218":"白音特拉乡","150922401":"化德县长顺工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150922.json
// module id = 556
// module chunks = 0